import { useRef, useState } from 'react'
import styles from './FilterTab.module.css';
import Checkbox from '../../../compoenets/Checkbox'
import { dataList } from '../../../constants'
import classMotion from '../../../assets/class_motion_02.mp4';
import regMotion from '../../../assets/reg_motion_02.mp4';

const MotionBtn=({name,src,isClick,onClick})=>{
    const motionRef=useRef(null);

    const handleMotionStart=()=>{
            motionRef.current.currentTime=0;
            motionRef.current?.play().catch(err=>{
                console.error("fail video :",err);
            });
    }

    const handleMotionStop=()=>{
        if(motionRef.current){
            motionRef.current.pause();
            motionRef.current.currentTime=motionRef.current.duration;
        }
    }

    return(
        <div
        className={`${styles['type-btn']} ${isClick&&styles['type-btn-on']}`} 
        onMouseEnter={handleMotionStart}
        onMouseLeave={handleMotionStop}
        onClick={onClick}>
            <video 
            ref={motionRef}
            preload="metadata"
            muted 
            onLoadedMetadata={()=>motionRef.current.currentTime=motionRef.current?.duration}
            className={`${styles['type-btn-background']} ${isClick&&styles['type-background-on']}`}>
                <source src={src} type="video/mp4"/>
            </video>
            <span>{name}</span>
        </div>
    )
}

export default function FilterTab({filter,onChange}){


    return(<>
        <div className={styles['filter-item']}>
            <div className={styles['filter-item-title']}>
                <span>Type</span>
            </div>
            <div className={styles['type-btn-wrap']}>
                <MotionBtn
                src={classMotion}
                name="Classification"
                isClick={filter.filters.type[0]=='classification'}
                onClick={()=>onChange("type","classification")}
                />
                <MotionBtn
                src={regMotion}
                name="Regression"
                isClick={filter.filters.type[0]=='regression'}
                onClick={()=>onChange("type","regression")}
                />
            </div>
        </div>
        <div className={styles['filter-item']}>
            <div className={styles['filter-item-title']}>
                <span>Dataset</span>
            </div>
            <div className={styles['dataset-btn-wrap']}>
                {dataList
                .filter(item=>filter.filters.type.length===0||filter.filters.type.includes(item.category.toLowerCase()))
                .map(item=>
                <button 
                key={item.target} 
                className={`
                    ${styles['dataset-btn']} 
                    ${filter.filters.dataset.includes(item.requiredName)&&styles['dataset-btn-on']}`
                }
                onClick={()=>onChange('dataset',item.requiredName)}
                >
                    <span>{item.requiredName}</span>
                </button>
                )}
            </div>
        </div>
        <div className={styles['filter-item']}>
            <div className={styles['filter-item-title']}>
                <span>Status</span>
            </div>
            <div className={styles['status-btn-wrap']}>
                <Checkbox 
                isChecked={filter.filters.status.includes('available')}
                onChange={()=>onChange('status','available')}
                text="Available"
                textStyle={styles['status-btn-text']}/>
                <Checkbox 
                isChecked={filter.filters.status.includes('unavailable')}
                onChange={()=>onChange('status','unavailable')}
                text="Unavailable"
                textStyle={styles['status-btn-text']}/>
            </div>
        </div>
    </>)
}